import { render, staticRenderFns } from "./AGeberDialog.vue?vue&type=template&id=a23a6360&scoped=true"
import script from "./AGeberDialog.vue?vue&type=script&lang=js"
export * from "./AGeberDialog.vue?vue&type=script&lang=js"
import style0 from "./AGeberDialog.vue?vue&type=style&index=0&id=a23a6360&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23a6360",
  null
  
)

export default component.exports